import axios from "axios";
import { Toast } from "components/ToastShow/ToastAlert";
import { MessageType } from "types/enum";
import { auth } from "./auth";
import { APP_URL } from "./constants";
import { trans } from "./helpers";
import { getEnv } from "../config/runtimeEnv";


var forbiddenCount =0
export let UserTabs: any = [];
const delay = (duration) =>
  new Promise(resolve => setTimeout(resolve, duration));

function clearSessionStorage() {
  sessionStorage.clear();
  localStorage.setItem('clearSessionStorage', Date.now()+"");
}


async function handleExit() {
  const Idtoken = localStorage.getItem("id_token")
  //////////////////////////////////////////////
 sessionStorage.removeItem("accept-data");
 localStorage.removeItem("token");
 localStorage.removeItem("id_token");
 localStorage.removeItem("refresh_token");
 localStorage.removeItem("token_expire");
 localStorage.removeItem("CurrentApplication");
 localStorage.removeItem("tabs");
////////////////////////////////////////////////
  try {
    sessionStorage.setItem("Logout","true")
 //window.location.href = `https://newauth.tadbir.biz/Account/Logout?returnUrl=http://127.0.0.1:3000/?logout=true`
window.location.href = `${getEnv("REACT_APP_AUTH_URL")}/Account/Logout?returnUrl=${getEnv("REACT_APP_AUTH_REDIRECT_URL")}/?logout=true`

  //  const openedWindow = window.open(`${getEnv("REACT_APP_AUTH_URL")}/endsession?id_token_hint=${Idtoken}&post_logout_redirect_uri=${getEnv("REACT_APP_AUTH_REDIRECT_URL")}`);
  //  await delay(300)
  //  openedWindow?.close();
  //  clearSessionStorage()
  //  window.location.href = "/"
  } catch (error) {

  }
}

export const http = axios.create({
  baseURL: APP_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  },
  timeout: 40000,
});

http.interceptors.request.use(
async function (config: any) {
    const lang = localStorage.getItem("DefaultLanguage");
    const token = localStorage.getItem("token");
    const ex = localStorage.getItem("token_expire");
         if (sessionStorage.getItem("taskID")) {
      config.headers["TAS_UID"] = sessionStorage.getItem("taskID");
    }
    let res = true;
    if (token) {
      res =await auth.checkTokenExpire();
    } else {
      auth.attempt();
    }

    if(!localStorage.getItem("token")){
      await delay(300)
      if (localStorage.getItem("token")) {
        res =await auth.checkTokenExpire();
      } else {
        auth.attempt();
      }
    }

    if (
      config.method == "post" ||
      config.method == "put" ||
      config.method == "delete"
    ) {
      document.body.classList.add("loading-indicator-"+lang);
    }

    if (sessionStorage.getItem("accept-data")) {
      config.headers["Accept-Data"] = sessionStorage.getItem("accept-data");
    }else{
      if(!config.url.includes("Profile")&&!config.url.includes("Resource")&&!config.url.includes("UserInfo")){
        console.log("ddd" ,config.url)
      handleExit() 
      }
    }
    if (res) {
      if (sessionStorage.getItem("accept-data")) {
        config.headers["Accept-Data"] = sessionStorage.getItem("accept-data");
      }
      if (
        config.headers["Accept-Language"] == undefined ||
        config.headers["Accept-Language"] == ""
      )
        config.headers["Accept-Language"] = lang;
      config.headers["Authorization"] = "Bearer " + localStorage.getItem("token");
      return config;
    } else {
      auth.attempt();
      if (
        config.headers["Accept-Language"] == undefined ||
        config.headers["Accept-Language"] == ""
      )
        config.headers["Accept-Language"] = lang;
      config.headers["Authorization"] = "Bearer " + localStorage.getItem("token");
      return config;
    }
  },
  function (error) {

  }
);


http.interceptors.response.use(
  async (res) => {
    const lang = localStorage.getItem("DefaultLanguage");
    try {

      if (res.config.method == "get") {
        document.body.classList.remove("loading-indicator-"+lang);
        return res;
      } else {
        if (res.data.MessageType == MessageType["confirm"]||res.data.MessageType == MessageType["confirmDelete"]) {
          res.config.params.Confirm = true;
          const confirm = await new Promise((resolve) => {
            let re: any;
            Toast(
              res.data.Message,
             res.data.MessageType,
              () => {
                re = http(res.config);
                resolve(re);
              },
              (res?.data?.Data?.[0]?.MessageType || res?.data?.Data?.[0]?.MessageType==0) ?res?.data?.Data  :  "",
              () => {
                document.body.classList.remove("loading-indicator-"+lang);
              }
            );
          });
          document.body.classList.remove("loading-indicator-"+lang);
          return confirm;
        } else {
          if (res?.data?.Data && (res.data.Data[0]?.MessageType || res.data.Data[0]?.MessageType==0 )) {
            Toast(
              res?.data.Message,
              MessageType[res.data.MessageType]?res.data.MessageType:0,
              () => {},
              res?.data?.Data,
              () => {document.body.classList.remove("loading-indicator-"+lang)},
            );
                   document.body.classList?.remove("loading-indicator-"+lang)
            return res;
          } else {
            if((res.data.MessageType || res.data.MessageType==0)&& res.data.MessageType!=MessageType["noDialog"] ){
              Toast(res.data.Message,MessageType[res.data.MessageType]?res.data.MessageType:0,
              );
            }
            document.body.classList.remove("loading-indicator-"+lang);
            return res;
          }
        }
      }
    } catch (error) {
      document.body.classList.remove("loading-indicator-"+lang);
    }
    document.body.classList.remove("loading-indicator-"+lang);
    document.body.classList.remove("loading-indicator-"+lang);
  },

  async (err) => {

    
    const lang = localStorage.getItem("DefaultLanguage");

    document.body.classList.remove("loading-indicator-"+lang);
    const statusCode = err?.response?.status;
    if(err?.response?.data instanceof Blob){
      err.response.data=JSON.parse(await new Response(err?.response?.data).text())
    }  
    if(forbiddenCount==20){
   handleExit()
    }
    if (statusCode == 401) {
      forbiddenCount +=1
      try {
 /*      const Idtoken = localStorage.getItem("id_token");
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("id_token");
      localStorage.removeItem("token_expire");
      localStorage.removeItem("CurrentApplication");

        if (UserTabs.length == 0) {
          const openedlogoutWindow = window.open(
            `${getEnv("REACT_APP_AUTH_URL")}/endsession?id_token_hint=${Idtoken}&post_logout_redirect_uri=${getEnv("REACT_APP_AUTH_REDIRECT_URL")}`
          );
          UserTabs = [...UserTabs, openedlogoutWindow];
        }
        UserTabs?.forEach((item) => {
          item?.close();
        });
        UserTabs = [];

        window.location.href = "/";
 */

        await auth.checkTokenExpire();
        const token = localStorage.getItem("token");
        err.response.config.headers["Authorization"] = "Bearer " + token
        await new Promise((resolve) => {
          let re = http(err?.response.config);
          resolve(re);
        });
      } catch (error) {}
    }  else if (statusCode == 403) {
      forbiddenCount +=1
      if(err.config.method != "get"){
        Toast("noaccess" ,MessageType.error)
      }
      err.response.data ={
        data:null ,
        MessageType : MessageType["error"],
        Message:"noaccess"
      }
      return Promise.reject(err);

    }else if (!err?.message.includes("timeout") &&err?.response?.data?.MessageType != MessageType["confirm"]&&err?.response?.data?.MessageType != MessageType["confirmDelete"]) { //confirm with error managed in api functions
      forbiddenCount =0
        if (err?.response?.data?.Data && (err?.response?.data?.Data[0]?.MessageType || err?.response?.data?.Data[0]?.MessageType==0)) {
          Toast(
            err?.response?.data.Message,
            MessageType.error,
          
            () => {},
            err?.response?.data?.Data,
            () => {document.body.classList.remove("loading-indicator-"+lang)},
          );
        } else if (!err?.response?.data?.Message) {
            Toast( trans("msg_serverexceptionerror") +(err?.response?.status?  " ( "+err?.response?.status+" )" :""),MessageType.error);
        } else {
        
        if(err?.response?.data?.MessageType!=MessageType["noDialog"] )
          Toast(err.response.data.Message,MessageType.error);
         return Promise.reject(err);

        }
        document.body.classList.remove("loading-indicator-"+lang);
      
    } else if (err?.message.includes("timeout ")) {
      forbiddenCount =0
      Toast(trans("Msg_ServerTimeOutError"),MessageType.error);
    }
    document.body.classList.remove("loading-indicator-"+lang);
    return Promise.reject(err);
  }
);





























